import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Vigilance at the Edge",
    body: "Security is not a product you buy — it is a posture you hold. Our officers and K9 teams train for the exact moment everyone else hopes never comes, so your perimeter never learns what failure feels like.",
  },
  {
    n: "02",
    title: "K9 Instinct & Dual Tactics",
    body: "A trained dog reads a threat 300 meters before a camera resolves a face. We pair certified dual-purpose K9s with handlers who move as one unit — deterrence, detection and pursuit in a single heartbeat.",
  },
  {
    n: "03",
    title: "Integrated Hardware Matrix",
    body: "Cameras that see in the dark. Fobs that log every crossing. Alarms that wake a response team, not a voicemail. Every sensor on your site reports into one command structure with one job: total accountability.",
  },
  {
    n: "04",
    title: "No-Compromise Defense",
    body: "We would rather decline a contract than dilute a standard. Every deployment begins with a ruthless risk audit and ends only when the site is measurably, demonstrably harder to breach than the day we arrived.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 sm:py-32 bg-[#0F1115] border-y border-white/10 overflow-hidden">
      <div className="absolute inset-0 grid-tactical opacity-40" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testid="manifesto-heading"
          overline="Doctrine / Manifesto"
          title="Four Chapters. One Standard."
          description="The operating principles behind every Frontline K9 deployment — read them the way our teams live them."
        />

        <div className="flex flex-col">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.06}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="group grid grid-cols-1 md:grid-cols-[160px_1fr_48px] gap-6 items-start py-10 border-t border-white/10 last:border-b hover:bg-white/[0.02] transition-colors duration-500 px-2 sm:px-4"
              >
                <span className="font-display font-black text-6xl sm:text-7xl text-stroke group-hover:[-webkit-text-stroke:1px_rgba(59,130,246,0.6)] transition-all duration-500">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight uppercase text-gray-100 mb-3 group-hover:text-blue-400 transition-colors duration-500">
                    Chapter {c.n} — {c.title}
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed max-w-3xl">{c.body}</p>
                </div>
                <ArrowRight className="hidden md:block w-6 h-6 text-gray-700 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-500 mt-2" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
